import React,{useState,useEffect} from 'react'
import AppHeader from '../../components/AppHeader'
import portalServices from '../../portalServices';
import { useLocation, useNavigate, useParams } from 'react-router-dom';


import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { useAlert } from '../../../../context/AlertContext';
import { ArrowCircleRight } from '@mui/icons-material';

import { Step, StepLabel, Stepper } from '@mui/material';
import CheckinBackButton from '../CheckinBackButton';
const Step2 = ({queue}) =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={1}>
        <Step>
          <StepLabel>{queue.title}</StepLabel>
        </Step>
        <Step>
          <StepLabel>Select Date And Service</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}

function SelectScheduleServicesPage() {

	const location = useLocation();
	const queue = location.state;

	const queueId = queue?queue.id:null;
	const navigate = useNavigate();
	const {AppAlert} = useAlert();

	const [serviceList,setServiceList] = useState(null);
	const [selectedDate,setSelectedDate] = useState(null);
	const [availableSlots,setAvailableSlot] = useState(null);


	const getAvailableSlots = () =>{
		console.log(queueId);
		if(selectedDate !== null){
			setAvailableSlot(null);
			setServiceList(null);
			let payload = {
				date: moment(selectedDate).format("YYYY-MM-DD"),
				queueId:queueId,
			}
			portalServices.getAvailableSlots(payload).then(res=>{
				setAvailableSlot(res.data.count);
				setServiceList(res.data.queueServiceList);
			}).catch(error=>{
				AppAlert(error.msg,"error")
			})
		}
	}

	useEffect(()=>{
		getAvailableSlots();
	},[selectedDate])



  const selectService = (service) =>{
      navigate("/schedule-checkin/form",{state:{queue,queue,service,service,selectedDate,selectedDate}})
  }

  useEffect(()=>{
	if(queue==null){
		navigate("/schedule-checkin/queue")
	}
  },[])


  return (
    <>
        <AppHeader/>
		{queue &&
        <div className='container'>
            <div className='row'>
				<CheckinBackButton/>
				<Step2 queue={queue} />
				<div className='col-md-6'>  
						<Calendar 
							onChange={setSelectedDate} 
							value={selectedDate}
							minDate={moment().add(1,"day").toDate()} 
							maxDate={moment().add(queue.maxFutureDays,"day").toDate()}   
						/>
				</div>

				{availableSlots && serviceList &&
					<div className='col-md-6'>
                        <div className='list-group rounded-0'>
                            <span className="list-group-item bg-dark text-white text-center">{availableSlots} Slots Available</span>
							<span className="list-group-item text-center">Select Service</span>
                            {serviceList && serviceList.map(service=>
                                <button type="button" onClick={()=>selectService(service)} class="list-group-item list-group-item-action text-primary fw-bold">{service.title} <ArrowCircleRight/>  </button>
                            )}
                        </div>
					</div>
				}
            </div>
        </div>
		}
		
    </>
  )
}

export default SelectScheduleServicesPage